import {Injectable} from '@angular/core';
import {Observable} from "rxjs/Observable";
import {HttpCommonService} from "./http-common.service";
import {Company} from "../components/search-box/search-box.component";

@Injectable()
export class RegisterEnterpService {

  constructor(private http: HttpCommonService) {
  }

  /**
   * 企业注册提交
   * @param {Company} company
   * @param formValue
   * @param cascadeData
   * @param file1
   * @param file2
   * @param file3
   * @returns {Observable<any>}
   */
  registerEnterp(company: Company, formValue: any, cascadeData: any, file1: any, file2: any, file3: any): Observable<any> {
    let params: any = {};
    //params.smsCode = formValue.stepTwoGroup.mobileProveCode;// 短信验证码
    params.companyUser = {
      username: company.creditCode,// 用户名
      companyId: company.id,// 公司ID
      companyName: company.companyName,// 企业名称
      legalPerson: company.legalPerson,// 法定代表人
      establishmentDate: company.establishmentDate,// 成立日期
      address: company.address// 企业地址
    };
    params.realnameAuthentication = {
      realName: formValue.stepTwoGroup.linkManName,// 真实姓名
      companyId: company.id,// 公司ID
      phone: formValue.stepTwoGroup.mobile,// 手机号码
      email: formValue.stepTwoGroup.email,// 电子邮箱
      cardNo: formValue.stepTwoGroup.identityNumber,// 身份证号
      cardPositive: {
        name: file1.name, // 身份证正面图片名称
        path: file1.path// 身份证正面图片路径
      },
      cardNegative: {
        name: file2.name, // 身份证反面图片名称
        path: file2.path// 身份证反面图片路径
      }
    };
    params.companyCertification = {
      bankAccountName: formValue.stepThreeGroup.enterpBankName,// 企业银行账户名
      companyId: company.id,// 公司ID
      bankDeposit: formValue.stepThreeGroup.openAccountBank,// 开户行
      bankLineNo: formValue.stepThreeGroup.openBankLineNo.bankLineNo,// 联行号
      bankAccountNo: formValue.stepThreeGroup.enterpBankNumber,// 企业银行账号
      provinceId: cascadeData[0].value,// 所属省ID
      provinceName: cascadeData[0].label,// 所属省名称
      cityId: cascadeData[1].value,// 所属市ID
      cityName: cascadeData[1].label,// 所属市名称
      //districtId:formValue.stepTwoGroup. ,// 所属区ID
      //districtName:formValue.stepTwoGroup. ,// 所属区名称
      //companyAddress: formValue.stepThreeGroup.enterpAddress// 企业地址
      companyAddress: '',
      businessLicence: {
        name: file3.name, // 营业执照名称
        path: file3.path// 营业执照图片路径
      }
    };
    return this.http.post('/user/center/xhsRest/registerCUser', params);
  }

  /**
   * 企业入驻
   * @param {string} companyId
   * @param formValue
   * @param cascadeData
   * @returns {Observable<any>}
   */
  certificationEnterp(companyId: string, formValue: any, cascadeData: any, subStatus: any, orderNo: any, file: any): Observable<any> {
    let params: any = {};
    params.companyId = companyId;// 公司ID
    params.companyCertification = {
      bankAccountName: formValue.stepThreeGroup.enterpBankName,// 企业银行账户名
      bankDeposit: formValue.stepThreeGroup.openAccountBank,// 开户行
      bankLineNo: formValue.stepThreeGroup.openBankLineNo.bankLineNo,// 联行号
      bankAccountNo: formValue.stepThreeGroup.enterpBankNumber,// 企业银行账号
      provinceId: cascadeData[0].value,// 所属省ID
      provinceName: cascadeData[0].label,// 所属省名称
      cityId: cascadeData[1].value,// 所属市ID
      cityName: cascadeData[1].label,// 所属市名称
      //districtId:formValue.stepTwoGroup. ,// 所属区ID
      //districtName:formValue.stepTwoGroup. ,// 所属区名称
      companyAddress: formValue.stepThreeGroup.enterpAddress, // 企业地址
      subStatus: subStatus,
      orderNo: orderNo,
      businessLicence: {
        name: file.name, // 营业执照名称
        path: file.path// 营业执照图片路径
      }
    };
    return this.http.post('/user/center/xhsRest/certifi/companyCertification', params);
  }

  /**
   * 查询银行编码（第三方核验）
   * @param {string} key
   * @returns {Observable<any>}
   */
  getBankCode(key: string): Observable<any> {
    return this.http.get('/user/center/xhsRest/getBankCode', {key: key});
  }

  /**
   * 查询联行号（第三方核验）
   * @param {string} key
   * @returns {Observable<any>}
   */
  getBankLineNo(key: string, provinceCode: string, cityCode: string, bankId: string): Observable<any> {
    return this.http.get('/user/center/xhsRest/getBankLineNo',
      {key: key, provinceCode: provinceCode, cityCode: cityCode, bankId: bankId});
  }

  /**
   * 身份证实名认证
   * @param formValue
   * @param file1
   * @param file2
   * @param file3
   * @returns {Observable<any>}
   */
  realNameCertification(formValue: any, file1: any, file2: any): Observable<any> {
    let params = {
      realName: formValue.stepTwoGroup.linkManName,// 真实姓名
      phone: formValue.stepTwoGroup.mobile,// 手机号码
      email: formValue.stepTwoGroup.email,// 电子邮箱
      cardNo: formValue.stepTwoGroup.identityNumber,// 身份证号,
      isRegister: '1',
      cardPositivePath: {
        name: file1.name, // 身份证正面图片名称
        path: file1.path// 身份证正面图片路径
      },
      cardNegativePath: {
        name: file2.name, // 身份证反面图片名称
        path: file2.path// 身份证反面图片路径
      }
    };
    return this.http.post('/user/center/xhsRest/savePerAuthInfo', params);
  }

  /**
   * 城市入驻
   */
  cityEnterApply(formValue: any): Observable<any> {
    let params: any = {};
    params.cityApply = {
      cityCoding: formValue.city[1],
      name: formValue.Name,
      phoneNo: formValue.PhoneNo,
      position: formValue.Position,
      applyIntro: formValue.ApplyIntro
    };
    return this.http.post('/city/credit/CityApply/cityEnterApply', params);
  }

  /**
   * 申请城市舆情报告
   */
  cityReportApply(formValue: any): Observable<any> {
    let params: any = {};
    params.cityApply = {
      cityCoding: formValue.city[1],
      name: formValue.Name,
      phoneNo: formValue.PhoneNo,
      position: formValue.Position,
      applyIntro: formValue.ApplyIntro
    };
    return this.http.post('/city/credit/CityApply/cityReportApply', params);
  }

  /**
   * 发送邮件
   */
  sendEmail(params: any): Observable<any> {
    return this.http.get('/user/center/xhsRest/sendEmail', {
      email: params.email,
      message: params.message,
      subject: params.subject
    });
  }

}




// WEBPACK FOOTER //
// E:/java/gd-project/credit-gd-web/src/app/services/register-enterp.service.ts